import React from 'react';
import { motion } from 'framer-motion';

const StudentDashboard = () => {
    return (
        <div>
            <div style={{ marginBottom: '2rem' }}>
                <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--color-secondary)', marginBottom: '0.5rem' }}>Hey Family, 👋</h1>
                <p style={{ color: '#666' }}>It's Monday and time to study! 💪</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
                {/* Widgets will go here */}
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}
                >
                    <h3 style={{ fontWeight: '600', marginBottom: '1rem' }}>My Progress</h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{ width: '60px', height: '60px', borderRadius: '50%', border: '4px solid var(--color-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                            68%
                        </div>
                        <div>
                            <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>204/300</div>
                            <div style={{ fontSize: '0.9rem', color: '#666' }}>Completed lessons</div>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}
                >
                    <h3 style={{ fontWeight: '600', marginBottom: '1rem' }}>Next Session</h3>
                    <div style={{ background: '#f8f9fa', padding: '1rem', borderRadius: '8px', borderLeft: '4px solid var(--color-accent)' }}>
                        <div style={{ fontWeight: '600' }}>GCSE Mathematics</div>
                        <div style={{ fontSize: '0.9rem', color: '#666' }}>Tomorrow, 14:00 - 15:00</div>
                        <div style={{ fontSize: '0.8rem', marginTop: '0.5rem', color: 'var(--color-primary)' }}>with Mr. Thompson</div>
                    </div>
                </motion.div>
            </div>

            <div style={{ marginTop: '2rem' }}>
                <h3 style={{ fontWeight: '600', marginBottom: '1rem' }}>Recent Activity</h3>
                <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #eee', padding: '0.5rem' }}>
                    {[1, 2, 3].map((i) => (
                        <div key={i} style={{ padding: '1rem', borderBottom: i < 3 ? '1px solid #f0f0f0' : 'none', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: 'var(--color-primary)' }}></div>
                            <div>
                                <div style={{ fontSize: '0.9rem', fontWeight: '500' }}>Assignments Graded</div>
                                <div style={{ fontSize: '0.8rem', color: '#666' }}>Physics Topic 4 result: 85/100</div>
                            </div>
                            <div style={{ marginLeft: 'auto', fontSize: '0.8rem', color: '#999' }}>2h ago</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StudentDashboard;
